module.exports = __webpack_public_path__ + "img/bag-w.2a1b9d09.svg";